import { render, staticRenderFns } from "./Func50Listagem.vue?vue&type=template&id=8f90d668"
import script from "./Func50Listagem.vue?vue&type=script&lang=js"
export * from "./Func50Listagem.vue?vue&type=script&lang=js"
import style0 from "./Func50Listagem.vue?vue&type=style&index=0&id=8f90d668&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports